<script>
  import LookupSelect from '../generic/LookupSelect.vue'
  import formFieldMixin from './form-field-mixin.js'

  export default {
    mixins: [
      formFieldMixin
    ],
    components: {
      LookupSelect
    },
    computed: {
      searchPlaceholder () {
        return this.$t(`${this.translations}.${this.propName}.searchPlaceholder`)
      },

      options () {
        return this.$store.getters[`${this.store}/${this.propName}_options`]
      },
      selected () {
        return this.$store.getters[`${this.store}/item`][this.propName]
      },
      selectedItem () {
        return this.$store.getters[`${this.store}/${this.propName}_selected`]
      },
      searchValue () {
        return this.$store.getters[`${this.store}/${this.propName}_search`]
      },
    },
    methods: {
      select (value) {
        this.$store.dispatch(`${this.store}/updateItem`, {[this.propName]: value})
      },
      search (search) {
        this.$store.dispatch(`${this.store}/search_${this.propName}`, search || null)
      }
    },
    props: {
      optionKey: {
        type: String,
        default: '@id'
      },
      clearButton: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <lookup-select
      :id="inputName"
      :placeholder="placeholder"
      :search-placeholder="searchPlaceholder"
      :icon="true"
      :optionKey="optionKey"
      :clearButton="clearButton"
      :state="!isInvalid"
      :disabled="isReadOnly"

      :options="options"
      :selected="value"
      :selected-item="selectedItem"
      :search-value="searchValue"
      @select="select"
      @search="search"
    >
      <template v-slot:selected-item="slotProps">
        <slot name="selected-item" v-bind:item="slotProps.item">{{slotProps.item}}</slot>
      </template>
      <template v-slot:item="slotProps">
        <slot name="item" v-bind:item="slotProps.item">{{slotProps.item}}</slot>
      </template>
    </lookup-select>
  </b-form-group>
</template>
